// Import nomme depuis 'bootstrap' (deja charge par main.js) et non depuis
// 'bootstrap/js/dist/modal' : ce second point d'entree embarque sa propre copie
// de Modal, donc son propre registre d'instances. Les deux copies se
// desynchroniseraient sur la meme modale (data-bs-dismiss en creant une
// seconde), en plus d'alourdir le bundle.
import { Modal } from 'bootstrap';
import { buildYoutubeIframe } from '../utils/youtubeEmbed';

/**
 * Popup de lecture mutualisee par les blocs .card-video, en desktop uniquement.
 *
 * La playlist n'est pas codee ici : elle est deduite des cartes presentes dans
 * la page au moment de l'ouverture (cf. CardVideo.playInModal), ce qui permet
 * de naviguer d'un temoignage a l'autre sans quitter la popup.
 */
export default class VideoModal {

    constructor($modal) {
        this.$modal = $modal;
        this.$player = $modal.querySelector('.js-video-modal-player');
        this.$title = $modal.querySelector('.js-video-modal-title');
        this.$dots = $modal.querySelector('.js-video-modal-dots');
        this.$prev = $modal.querySelector('.js-video-prev');
        this.$next = $modal.querySelector('.js-video-next');

        this.playlist = [];
        this.index = 0;

        this.$prev.addEventListener('click', () => this.go(-1));
        this.$next.addEventListener('click', () => this.go(1));

        this.$modal.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
                this.go(-1);
            } else if (e.key === 'ArrowRight') {
                this.go(1);
            }
        });

        // Vider le lecteur a la fermeture : c'est ce qui coupe la lecture.
        // Sans cela l'iframe reste dans le DOM et le son continue en fond.
        this.$modal.addEventListener('hidden.bs.modal', () => {
            this.$player.innerHTML = '';
        });
    }

    open(playlist, index) {
        this.playlist = playlist;
        this.index = index;
        this.buildDots();
        this.render();

        Modal.getOrCreateInstance(this.$modal).show();
    }

    go(step) {
        if (this.playlist.length < 2) {
            return;
        }

        const total = this.playlist.length;
        this.index = (this.index + step + total) % total;
        this.render();
    }

    buildDots() {
        this.$dots.innerHTML = '';

        if (this.playlist.length < 2) {
            return;
        }

        this.playlist.forEach((item, i) => {
            const $dot = document.createElement('button');
            $dot.type = 'button';
            $dot.className = 'video-modal-dot';
            $dot.setAttribute('aria-label', item.title || `Temoignage ${i + 1}`);
            $dot.addEventListener('click', () => {
                this.index = i;
                this.render();
            });
            this.$dots.appendChild($dot);
        });
    }

    render() {
        const item = this.playlist[this.index];
        const multiple = this.playlist.length > 1;

        this.$player.innerHTML = '';
        this.$player.appendChild(buildYoutubeIframe(item.videoId, item.title));

        this.$title.textContent = item.title || '';

        this.$prev.hidden = !multiple;
        this.$next.hidden = !multiple;

        Array.from(this.$dots.children).forEach(($dot, i) => {
            $dot.classList.toggle('active', i === this.index);
            $dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });
    }

}

let instance = null;

/**
 * Instance unique, creee au premier usage : la popup est rendue une seule fois
 * par page par le partial _VideosTemoignages.cshtml.
 */
export function getVideoModal() {

    const $modal = document.getElementById('video-modal');

    if (!$modal) {
        return null;
    }

    if (!instance) {
        instance = new VideoModal($modal);
    }

    return instance;
}
